<article
	class="note-item"
	[class.note-editing]="isEditing"
	[class.note-clickable]="isCardClickable"
	[attr.tabindex]="cardTabIndex"
	(click)="onCardClick($event)"
	(keydown)="onCardKeydown($event)"
>
	<tlk-card [padding]="16">
		<div class="note-header" *ngIf="!isEditing || isPrintContext">
			<span class="note-author tlk-typo-label tlk-typo-label_size_m">{{ createdByName ?? '—' }}</span>
			<div class="note-meta">
				<span class="note-date tlk-typo-label tlk-typo-label_size_m" *ngIf="note?.dateCreated">
					{{ note.dateCreated | date:(dateFormat ?? 'mediumDate') }}
					<ng-container *ngIf="minutesAgo !== null"
						><span class="note-date-sep">|</span
						><ng-container *ngIf="showRelativeTime" [ngSwitch]="minutesAgo">
							<span *ngSwitchCase="0">{{ 'NotesSection.JustNowLabel' | translate }}</span>
							<span *ngSwitchCase="1">{{ 'NotesSection.MinuteAgoLabel' | translate: { num: 1 } }}</span>
							<span *ngSwitchDefault>{{ 'NotesSection.MinutesAgoLabel' | translate: { num: minutesAgo } }}</span>
						</ng-container
						><span *ngIf="!showRelativeTime">{{ note.dateCreated | date:'h:mm a' }}</span></ng-container
					>
				</span>
				<div class="note-actions" *ngIf="!isPrintContext">
					<button
						*ngIf="canDelete"
						tlkButton
						variant="ghost"
						size="l"
						class="note-action-button"
						data-testid="notes-delete"
						(click)="onRemoveClick($event)"
						[attr.aria-label]="'Common.Delete' | translate"
					>
						<tlk-delete-icon />
					</button>
				</div>
			</div>
		</div>
		<div class="note-content-wrapper">
			<div *ngIf="!isEditing || isPrintContext" class="note-content-text tlk-typo-label tlk-typo-label_size_m">{{ (content ?? '').trimStart() }}</div>
			<rx-textarea
				*ngIf="showEditTextarea"
				#editTextarea="rxTextarea"
				class="note-edit-textarea"
				[formControl]="editControl"
				[rows]="3"
				(submitted)="onSaveEdit($event)"
				(cancelled)="onCancelEdit()"
			>
				<button
					rxTextareaCancel
					tlkButton
					variant="secondary"
					size="l"
					type="button"
					(click)="editTextarea.cancel(); $event.stopPropagation()"
					[attr.aria-label]="'NotesSection.Cancel' | translate"
				>
					{{ 'NotesSection.Cancel' | translate }}
				</button>
				<button
					rxTextareaSubmit
					tlkButton
					variant="primary"
					size="l"
					type="button"
					[disabled]="isSaveDisabled"
					(click)="editTextarea.submit(); $event.stopPropagation()"
					[attr.aria-label]="'NotesSection.Save' | translate"
				>
					{{ 'NotesSection.Save' | translate }}
				</button>
			</rx-textarea>
		</div>
	</tlk-card>
</article>
